<div>
  <div mat-dialog-content>
    <form>
      <div class="row m-t-20">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-2">
          <mat-form-field appearance="outline" class="example-full-width">
            <mat-label>MEDICAMENTO</mat-label>
            <input
              (input)="searchMedicamentsByKeyPress($event)"
              [(ngModel)]="searchMedicament"
              aria-autocomplete="none"
              autocomplete="nope"
              matInput
              name="medicamento"
              type="text"
            />
          </mat-form-field>
        </div>
      </div>
    </form>
  </div>
</div>
<div [hidden]="!isDataLoaded" class="row">
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
    <div class="card">
      <div class="body overflow-auto">
        <div class="responsive_table">
          <table [dataSource]="dataSource" class="mat-cell advance-table" mat-table matSort>

            <ng-container matColumnDef="id">
              <mat-header-cell *matHeaderCellDef mat-sort-header>ID</mat-header-cell>
              <mat-cell *matCellDef="let row" matTooltip="{{row.id}}">{{ row.id }}</mat-cell>
            </ng-container>


            <ng-container matColumnDef="nombre">
              <mat-header-cell *matHeaderCellDef mat-sort-header>NOMBRE</mat-header-cell>
              <mat-cell *matCellDef="let row" matTooltip="{{row.nombre}}"><span
                class="mobile-label">Nombre:</span>{{ row.nombre }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="summary">
              <mat-header-cell *matHeaderCellDef mat-sort-header>DESCRIPCION</mat-header-cell>
              <mat-cell *matCellDef="let row" matTooltip="{{row.summary}}"><span
                class="mobile-label">Descripcion:</span>{{ row.summary }}
              </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple>
            </mat-row>
          </table>
          <!-- Loading spinner -->
          @if (data.isTblLoading) {
            <div class="tbl-spinner">
              <mat-progress-spinner color="primary" [diameter]="40" mode="indeterminate">
              </mat-progress-spinner>
            </div>
          }
          @if (!data.isTblLoading) {
            <div class="no-results" [style.display]="dataSource.renderedData.length === 0 ? '' : 'none'">
              Sin datos
            </div>
          }
          <mat-paginator [length]="dataSource.filteredData.length" [pageIndex]="0" [pageSizeOptions]="[5, 10, 25, 100]"
                         [pageSize]="10">
          </mat-paginator>
        </div>
      </div>
    </div>
  </div>
</div>

